
<div v-if="numbers">
    <v-row class="no-frame" v-for="(number, index) in preview" :key="index">
        <v-col class="no-frame col-auto">
            <v-icon size="16" style="margin-top: -7px">X {{ number.type.symbol }}</v-icon>
        </v-col>

        <v-col class="no-frame col-auto" style="font-size: 14px;">
            <div class="v-flex">
                <f-copy-text :text="phone(number.number)" :color="color" />
                <div v-if="numbers.length > 3 && index === 2" class="ml-1" :class="color">
                    {{ '(+' + (numbers.length - 3) + ")"  }}
                </div>
            </div>
        </v-col>
    </v-row>
</div>
